/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import MDInput from "components/MDInput";
import MDPopup from "components/MDPopup";
import MDAlert from "components/MDAlert";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";

import { Link } from "react-router-dom";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import Icon from "@mui/material/Icon";

import UserCreate from "./userCreate";

import { useAuthContext } from "../../../hooks/useAuthContext";

import { httpGet, httpPost, httpDelete } from "../../../api";

import {formatDate, DownloadFile, shortenText} from "../../../utils"

const Tables = (props) => {

  const endPoint = "/user/all";

  const { user } = useAuthContext();

  const columns = [
      { Header: "User ID", accessor: "id", align: "center" },
      { Header: "First Name", accessor: "first_name", align: "center" },
      { Header: "Second Name", accessor: "second_name", align: "center" },
      { Header: "Email", accessor: "email", align: "center" },
      { Header: "Role", accessor: "role", align: "center" },
      /*{ Header: "Action", accessor: "action", align: "center" },*/

    ]

  const [ rows, setRows ] = useState([]);

  const [ TableData, setTableData ] = useState([]);

  const [ refrechedData, setRefrechedData ] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
        const response = await httpGet(process.env.REACT_APP_URL_BASE + endPoint);
        
        if (response.status != 200){
            return
        }

        setTableData(await response.json());

        setRefrechedData(!refrechedData);
    }

    if (refrechedData) {
      fetchData();
    }
  }, [refrechedData])

  useEffect(() => {
    setRows(TableData.map((row) => {

          const action = [];
     
          return {
            ...row,

            action: action

          }
        }))
      
  }, [TableData])


  const [openCreate, setOpenCreate] = useState(false);

  const handleCloseCreate = () => {
    setOpenCreate(false);
  }

  return (
    <DashboardLayout>

      <UserCreate open={openCreate} close={handleCloseCreate} setRefreshed={setRefrechedData}/>

      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="error"
                borderRadius="lg"
                coloredShadow="info"

                sx={{width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center"}}
              >
                <MDTypography variant="h6" color="white">
                  List of Documents
                </MDTypography>

                <MDButton variant="gradient" color="success" onClick={() => {setOpenCreate(true)}}>
                  Create
                </MDButton>
              </MDBox>

              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  entriesPerPage={true}
                  showTotalEntries={true}
                  noEndBorder
                  canSearch
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
